import { GET_MENSAJERIA, SET_MENSAJERIA } from '../types/mensajeria.types'

export async function getMensajeria(mensajeria) {
  console.log("Mensajeria.Action.getMensajeria mensajeria: ", mensajeria);
  return {
    type: GET_MENSAJERIA,
    payload: mensajeria
  }
}

export async function setMensajeria(mensajeria) {
  console.log("Mensajeria.Action.setMensajeria mensajeria: ", mensajeria);
  return {
    type: SET_MENSAJERIA,
    payload: mensajeria
  }
}